/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const InventoryProductListPage = lazyLoad(
  () => import('./index'),
  module => module.InventoryProductListPage
);
